/* eslint-disable no-console */
import { selectParams } from '../../../../store/location/selectors';
import { requireAuthentication } from '../../guards';

export const path = '/payout/complete-payout-request';
export const component = 'CompletePayoutRequest';
export const thunk = () => (dispatch, getState) => {
  const state = getState();
  const { token } = selectParams(state);

  console.log('complete-payout-request thunk: token:', token);
  requireAuthentication(dispatch, getState);
};
